import { render, staticRenderFns } from "./Template32.vue?vue&type=template&id=46fd83c2&scoped=true&"
import script from "./Template32.vue?vue&type=script&lang=js&"
export * from "./Template32.vue?vue&type=script&lang=js&"
import style0 from "./Template32.vue?vue&type=style&index=0&id=46fd83c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fd83c2",
  null
  
)

export default component.exports